import './Subiecte.css';

export default function Subiecte2014() {
    return (
        <div className="container my-4">
            <h2 className="fw-bold mb-4 subjectTitle">{'<'}Subiecte 2014{'/>'}</h2>
            <div className="mb-4">
                <h5>1. <strong>August</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2014/SubiectAugust2014MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2014/SubiectAugust2014MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2014/BaremAugust2014MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2014/SubiectAugust2014SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2014/SubiectAugust2014SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2014/BaremAugust2014SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>2. <strong>Iunie</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2014/SubiectIunie2014MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2014/SubiectIunie2014MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2014/BaremIunie2014MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2014/SubiectIunie2014SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2014/SubiectIunie2014SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2014/BaremIunie2014SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>3. <strong>Sesiunea Specială</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2014/SubiectSpeciala2014MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>
                            </li>
                            <li>
                                <a href="/subiecte/2014/BaremSpeciala2014MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>4. <strong>Simulare</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2014/SubiectSimulare2014MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2014/SubiectSimulare2014MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2014/BaremSimulare2014MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2014/SubiectSimulare2014SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2014/SubiectSimulare2014SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2014/BaremSimulare2014SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>5. <strong>Model</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2014/SubiectModel2014MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2014/SubiectModel2014MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2014/BaremModel2014MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2014/SubiectModel2014SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2014/SubiectModel2014SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2014/BaremModel2014SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    );
}